import { vars } from '@croquiscom-pvt/zds-tokens';

import { numberWithCommas } from '@common/utils';

import { Message } from '../types';

export function getEasyPaymentRewardMessage() {
  const getEasyPaymentTitle = (reward: number, icon_url: string, color: string): Message => {
    return {
      sections: [
        {
          type: 'icon',
          icon_url,
          style: { width: 16, height: 16, marginRight: 4 },
        },
        {
          type: 'fixed',
          text: `계좌 간편결제 시 최대`,
        },
        {
          type: 'fixed',
          text: ` ${numberWithCommas(reward)}P`,
          style: { color: color || vars.color.accentPinkPrimary, fontWeight: 500 },
        },
        {
          type: 'ellipsis',
          text: ' 적립',
        },
      ],
    };
  };

  return {
    getEasyPaymentTitle,
  };
}
